var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base_card",class:`base_card__${_vm.type} base_card__${_vm.size}`},[_c('div',{staticClass:"base_card__header",class:_vm.headerBorder ? 'border-bottom' : ''},[(_vm.$slots.title)?_vm._t("title"):_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2),_c('div',{staticClass:"base_card__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }